import { compilations } from "@/mocks/archive";
import Reveal from "./Reveal";
import SectionHead from "./SectionHead";

export default function CompilationIndex() {
  const total = compilations.reduce((sum, c) => sum + c.count, 0);

  return (
    <section id="comp" className="border-y border-background-200/70 bg-foreground-950 text-background-50">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <Reveal>
          <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between md:mb-10">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-400">
                跨人物打包 · 题材索引
              </p>
              <h4 className="mt-2 flex flex-wrap items-center gap-3 font-heading text-2xl font-black tracking-tight md:text-3xl">
                <span className="inline-flex h-8 items-center rounded-md bg-accent-500 px-2.5 text-sm font-bold text-foreground-950 md:h-9">
                  合集
                </span>
                事件合集索引
              </h4>
              <p className="mt-3 max-w-2xl text-sm leading-6 text-background-200/80 md:text-[15px]">
                不想按人物，就按题材点单——六大主题把散落的事件收进各自格子里，每格即一份可整包下翻的合集。
              </p>
            </div>
            <div className="text-right">
              <div className="font-heading text-5xl font-black leading-none text-accent-400 md:text-6xl">
                {total}
              </div>
              <div className="mt-1 text-xs text-background-300">归档事件 · 六个主题包</div>
            </div>
          </div>
        </Reveal>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
          {compilations.map((c, i) => (
            <Reveal key={c.theme} delay={(i % 3) * 80}>
              <a
                href="#deep"
                className="group relative flex h-full flex-col rounded-lg border border-background-800 bg-background-100/60 p-5 transition-all hover:border-primary-400 hover:bg-background-100/40 md:p-6"
              >
                <div className="flex items-start justify-between">
                  <span className="font-heading text-4xl font-black leading-none text-background-700 transition-colors group-hover:text-primary-400">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div className="flex items-center gap-2 text-xs text-background-300">
                    <span className="rounded-md bg-background-800 px-2 py-1">{c.years}</span>
                    <span className="font-semibold text-accent-400">{c.count} 事件</span>
                  </div>
                </div>
                <h5 className="mt-5 font-heading text-lg font-bold leading-snug text-background-50 group-hover:text-primary-300">
                  {c.theme}
                </h5>
                <p className="mt-2 flex-1 text-[13px] leading-6 text-background-200/75">{c.desc}</p>
                <div className="mt-5 flex flex-wrap items-center gap-2 border-t border-background-800 pt-4">
                  {c.tags.map((t) => (
                    <span key={t} className="rounded-md bg-background-800/80 px-2 py-0.5 text-[11px] text-background-300">
                      {t}
                    </span>
                  ))}
                  <span className="ml-auto inline-flex items-center gap-1 text-xs font-medium text-accent-300">
                    开合集
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}